/**
 * An organization's users: its memberships, each addressed by platform user id.
 *
 * Platform staff may list them; changing a role or removing a member takes a
 * platform admin (or the organization's own client admin). The agent refuses
 * to demote or remove the last client admin with a 409.
 */
import { apiDelete, apiGet, apiPatch } from '../client.js';
import type { OrganizationRole, OrgMembership } from '../types.js';

/** Everyone with a membership in the organization, active or not. */
export function listOrganizationUsers(organizationId: string): Promise<OrgMembership[]> {
  return apiGet<OrgMembership[]>(`/api/v1/organizations/${organizationId}/users`);
}

/** Sets one member's role in the organization. */
export function changeOrganizationUserRole(
  organizationId: string,
  userId: string,
  role: OrganizationRole,
): Promise<OrgMembership> {
  return apiPatch<OrgMembership>(`/api/v1/organizations/${organizationId}/users/${userId}`, {
    role,
  });
}

/** Ends one person's membership in the organization. */
export function removeOrganizationUser(organizationId: string, userId: string): Promise<void> {
  return apiDelete<void>(`/api/v1/organizations/${organizationId}/users/${userId}`);
}
